import { render, staticRenderFns } from "./PanelDetailsPage.vue?vue&type=template&id=49d4006c&scoped=true"
import script from "./PanelDetailsPage.vue?vue&type=script&lang=js"
export * from "./PanelDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./PanelDetailsPage.vue?vue&type=style&index=0&id=49d4006c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4006c",
  null
  
)

export default component.exports